import { Directive, Input, HostBinding, HostListener, OnInit, OnDestroy } from '@angular/core';
import { KeyboardService } from 'src/app/services/keyboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appKeyboardKey]'
})
export class KeyboardKeyDirective implements OnInit, OnDestroy {
  private _values: string[];
  private isShifted: boolean;
  private isAlt: boolean;
  private unsubscribe$ = new Subject<void>();


  @Input('appKeyboardKey') values: string;

  @HostBinding('innerText') currentValue: string;

  constructor(private keyboard: KeyboardService) { }

  ngOnInit() {
    this._values = this.values.split(' ');
    this.currentValue = this._values[0];

    this.keyboard.shiftChanged
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(shift => {
        this.isShifted = shift;
        this.updateCurrentValue();
      });

    this.keyboard.altChanged
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(alt => {
        this.isAlt = alt;
        this.updateCurrentValue();
      });


  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  updateCurrentValue() {
    if (!this.isAlt) {
      if (!this.isShifted) {
        this.currentValue = this._values[0];
      } else {
        this.currentValue = this._values[0].toUpperCase();
      }
    } else {
      if (!this.isShifted) {
        this.currentValue = this._values[1];
      } else {
        this.currentValue = this._values[2];
      }
    }
  }

  @HostListener('click')
  onClick() {
    this.keyboard.fireKeyPressed(this.currentValue);
  }
}
